import React from "react";
import { useSelector } from "react-redux";
import PortfolioImg from "../../assest/Portfilo-1.png";
import ArrowImg from "../../assest/arrow.png";
import { Link } from "react-router-dom";

// Translation dictionaries
const translations = {
  gb: {
    heading: "Etihad Gharbia Project Highlights",
    subheading:
      "Showcasing excellence in contracting, equipment rental, manpower supply, and transportation.",
    viewAll: "View All",
    project: {
      title: "Ministry of Health Upgrade",
      description:
        "Full manpower & equipment deployment for national infrastructure development.",
      location: "Riyadh, KSA",
      client: "Ministry of Health",
      year: "2022",
      duration: "1Y 6M",
    },
  },
  sa: {
    heading: "إبرازات مشروع اتحاد غربية",
    subheading:
      "عرض التميز في المقاولات، تأجير المعدات، توفير القوى العاملة، وخدمات النقل.",
    viewAll: "عرض الكل",
    project: {
      title: "ترقية وزارة الصحة",
      description:
        "نشر كامل للقوى العاملة والمعدات لتطوير البنية التحتية الوطنية.",
      location: "الرياض، المملكة العربية السعودية",
      client: "وزارة الصحة",
      year: "2022",
      duration: "سنة و6 أشهر",
    },
  },
  fr: {
    heading: "Points forts du projet Etihad Gharbia",
    subheading:
      "Mise en avant de l'excellence dans les contrats, la location d'équipements, la fourniture de main-d'œuvre et le transport.",
    viewAll: "Voir tout",
    project: {
      title: "Mise à niveau du ministère de la Santé",
      description:
        "Déploiement complet de main-d'œuvre et d'équipements pour le développement d'infrastructures nationales.",
      location: "Riyad, Arabie Saoudite",
      client: "Ministère de la Santé",
      year: "2022",
      duration: "1 an et 6 mois",
    },
  },
  de: {
    heading: "Höhepunkte des Projekts Etihad Gharbia",
    subheading:
      "Präsentation von Exzellenz in Auftragsvergabe, Geräteverleih, Personalbereitstellung und Transport.",
    viewAll: "Alle anzeigen",
    project: {
      title: "Modernisierung des Gesundheitsministeriums",
      description:
        "Voller Einsatz von Arbeitskräften und Ausrüstung für die Entwicklung nationaler Infrastruktur.",
      location: "Riad, Saudi-Arabien",
      client: "Gesundheitsministerium",
      year: "2022",
      duration: "1 Jahr 6 Monate",
    },
  },
};

const Portfolio = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;

  return (
    <section
      className="portfolio-section py-5 bg-white"
      dir={language === "sa" ? "rtl" : "ltr"}
    >
      <div className="container">
        {/* Heading */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4 gap-3">
          <div className="text-center text-md-start">
            <h2 className="fw-bold text-dark mb-2">
              {t.heading.split(" ")[0]}{" "}
              <span className="text-primary">
                {t.heading.split(" ").slice(1).join(" ")}
              </span>
            </h2>
            <p className="text-muted mb-0" style={{ maxWidth: "500px" }}>
              {t.subheading}
            </p>
          </div>
          <Link
            to="/view-project"
            className="btn btn-danger rounded-pill px-4 d-flex align-items-center gap-2 text-white text-decoration-none"
          >
            {t.viewAll}
            <img
              src={ArrowImg}
              alt="arrow"
              style={{ width: "32px", height: "32px" }}
            />
          </Link>
        </div>

        {/* Portfolio Cards */}
        <div className="row g-4">
          {[1, 2, 3].map((item, idx) => (
            <div className="col-12 col-sm-6 col-md-4" key={idx}>
              <div
                className="position-relative portfolio-card shadow-lg rounded-4 overflow-hidden border border-light-subtle h-100"
                style={{
                  transform: idx === 0 ? "rotate(-3deg)" : "none",
                  transition: "transform 0.3s ease",
                }}
              >
                <img
                  src={PortfolioImg}
                  alt="Project"
                  className="img-fluid w-100 h-100 object-fit-cover"
                  style={{ maxHeight: "300px" }}
                />

                {/* Overlay info only on first card */}
                {idx === 0 && (
                  <div
                    className="position-absolute bg-dark text-white p-3 p-sm-4 rounded-4 shadow info-overlay-custom text-start"
                    style={{
                      width: "90%",
                      zIndex: 5,
                      border: "1px solid rgba(255,255,255,0.1)",
                      backdropFilter: "blur(6px)",
                    }}
                  >
                    <h5 className="fw-bold mb-2">{t.project.title}</h5>
                    <p className="small mb-2">{t.project.description}</p>
                    <ul className="list-unstyled mb-0 small">
                      <li>
                        <i className="bi bi-geo-alt-fill me-2 text-danger"></i>
                        {t.project.location}
                      </li>
                      <li>
                        <strong>
                          {language === "sa" ? "العميل" : "Client"}:
                        </strong>{" "}
                        {t.project.client}
                      </li>
                      <li>
                        <strong>{language === "sa" ? "السنة" : "Year"}:</strong>{" "}
                        {t.project.year}
                      </li>
                      <li>
                        <strong>
                          {language === "sa" ? "المدة" : "Duration"}:
                        </strong>{" "}
                        {t.project.duration}
                      </li>
                    </ul>
                  </div>
                )}

                {/* Arrow icon overlay */}
                <div
                  className="arrow-overlay-hover position-absolute bg-danger rounded-circle d-flex align-items-center justify-content-center"
                  style={{
                    width: "40px",
                    height: "40px",
                    top: "15px",
                    right: "15px",
                    transition: "all 0.3s ease-in-out",
                    cursor: "pointer",
                  }}
                >
                  <img
                    src={ArrowImg}
                    alt="arrow"
                    style={{
                      width: "24px",
                      height: "24px",
                      transition: "transform 0.3s ease",
                    }}
                    className="arrow-image"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Hover & Overlay Styling */}
      <style>{`
        .portfolio-card:hover .arrow-overlay-hover {
          background-color: #bb2d3b;
          transform: translate(-5px, -50%);
          box-shadow: 0 5px 15px rgba(0,0,0,0.2);
        }
        .portfolio-card:hover {
          transform: translateY(-5px) rotate(0deg);
          transition: transform 0.3s ease;
        }
        .portfolio-card:hover .arrow-image {
          transform: translateX(5px);
        }
        .info-overlay-custom {
          top: 70%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        @media (max-width: 576px) {
          .info-overlay-custom {
            top: 75%;
            font-size: 14px;
          }
        }
      `}</style>
    </section>
  );
};

export default Portfolio;
